import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ProgressSpinnerSize } from "./progress-spinner-size";

/**
 * A loading spinner component that wraps PrimeNG's ProgressSpinner with deskbird sizes.
 * Use this component to indicate processing operations.
 *
 */
@Component({
  selector: "db-progress-spinner",
  templateUrl: "./progress-spinner.component.html",
  imports: [ProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressSpinnerComponent {
  /**
   * The size of the progress spinner.
   * - `sm`: Small size, typically used for icon buttons or inline loading states
   * - `md`: Medium size (default), used for general loading states
   */
  size = input<ProgressSpinnerSize>("md");

  protected isSmallSize = computed(() => this.size() === "sm");
  protected isMediumSize = computed(() => this.size() === "md");
}
